import React from 'react'
import { useAppStore } from '@/hooks/useAppStore'
import type { Screen } from '@/types'

interface TopbarProps {
  centerContent?: React.ReactNode
  backTo?: Screen
  backLabel?: string
}

export function Topbar({ centerContent, backTo, backLabel = '← Back' }: TopbarProps) {
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <header className="relative z-10 flex items-center justify-between px-5 py-3 bg-white/5 border-b border-white/10 backdrop-blur-sm">
      {/* Logo */}
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-sun to-sun-light flex items-center justify-center text-lg shadow-glow-sun">
          🧭
        </div>
        <div>
          <div className="text-lg font-black leading-none text-white">
            Yon<span className="text-sun-pale">der</span>
          </div>
          <div className="text-[10px] font-semibold text-white/50 leading-none mt-0.5 tracking-wide">
            by Imaginarium · families
          </div>
        </div>
      </div>

      {/* Center */}
      {centerContent && (
        <div className="text-[11px] font-bold text-white/70">{centerContent}</div>
      )}

      {/* Back */}
      {backTo && (
        <button
          onClick={() => setScreen(backTo)}
          className="text-[11px] font-bold text-white/80 bg-white/10 border border-white/20 px-4 py-1.5 rounded-full hover:bg-white/20 transition-colors"
        >
          {backLabel}
        </button>
      )}
      {!backTo && <div className="w-16" />}
    </header>
  )
}
